import { Grid } from '@mui/material';
import { SiteInfoBox } from './ReviewSiteInfoBox';

interface Site {
  name: string;
  price: number | null;
  rating: number| null;
  count: number| null;
  url: string| null;
}

interface SiteInfoGridProps {
  sites: Site[];
  dense?: boolean;
}

export const SiteInfoGrid = ({ sites, dense = false }: SiteInfoGridProps) => {
  return (
    <Grid
      container
      spacing={dense ? 0.5 : 0}
      direction={dense ? "column" : "row"}
      justifyContent={dense ? "flex-start" : "space-evenly"}
      alignItems={dense ? "stretch" : "center"}
      sx={{ minWidth: 0, overflow: "hidden" }}
    >
      {sites.map((site, idx) => (
        <Grid
          key={idx}
          sx={{
            minWidth: 0,
            width: dense ? "100%" : "auto",        // ★ denseは全幅
            flex: dense ? "0 0 auto" : "0 0 auto", // ★ PCも崩さない
          }}
        >
          <SiteInfoBox
            name={site.name}
            price={site.price}
            rating={site.rating}
            count={site.count}
            url={site.url}
            dense={dense}
          />
        </Grid>
      ))}
    </Grid>
  );
};
